<ng-container *ngIf="{
  row: columnData | async,
  adata: additionData | async
} as $">
<div class="flex align-items-center">
    <div class="w-4rem">
        <p-tag severity="warning" *ngIf="$.row && $.row.refund_isvoid ; else showStatus" styleClass="text-xxs font-normal uppercase white-space-nowrap" >Void</p-tag>
        <ng-template #showStatus>
          <p-tag *ngIf="$.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'initiated'  || $.row[$.adata.fetch_key] === '1' )" severity="success"
          styleClass="text-xxs font-normal uppercase white-space-nowrap">Initiated</p-tag>
        <p-tag *ngIf="$.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'refunded' || $.row[$.adata.fetch_key] === '2' )" severity="warning"
          styleClass="text-xxs font-normal uppercase white-space-nowrap">Refunded</p-tag>
        <p-tag *ngIf="$.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'failed' || $.row[$.adata.fetch_key] === '3' )" severity="danger"
          styleClass="text-xxs font-normal uppercase white-space-nowrap">Failed</p-tag>
        </ng-template>
    </div>
  </div>
  </ng-container>